// The English source, locales/en.json: every platform phrase the web says, by key.
// Staff keys as written; kiosk.<key>; book.<key>. Importing this registers it.
import en from './locales/en.json'
import { addEnglish } from './catalog'

/** Every key en.json has: a typo in say('x.y') fails typecheck. */
export type PhraseKey = keyof typeof en

/** The staff screens' keys. */
export type StaffKey = Exclude<PhraseKey, `kiosk.${string}` | `book.${string}`>

/** The kiosk's and boards' keys, without kiosk. */
export type KioskKey = PhraseKey extends infer K ? (K extends `kiosk.${infer R}` ? R : never) : never

const table: Record<string, string> = en
addEnglish(table)

export interface SourcePhrase {
  key: string
  en: string
}

let all: SourcePhrase[] | undefined

export function sourcePhrases(): SourcePhrase[] {
  all ??= Object.keys(table)
    .sort()
    .map((key) => ({ key, en: table[key]! }))
  return all
}

/** key → English, for every platform phrase. */
export function englishTable(): Record<string, string> {
  return table
}

export function hasEnglish(key: string): boolean {
  return Object.prototype.hasOwnProperty.call(table, key)
}
